import styled from "styled-components";

import { motion } from "@enkor/framer-motion";

import { Typo } from "@enkor/design/components";
import { grayScale } from "@enkor/design/colors";

export const Container = styled(motion.div)`
  position: absolute;
  top: 50%;
  left: 50%;

  width: calc(100% - 48px);
  max-width: 327px;
  height: fit-content;
  padding: 32px 24px 24px;
  border-radius: 8px;

  background-color: ${grayScale[300]};

  transform: translate(-50%, -50%);
`;

export const ModalHeader = styled(Typo.Heading)`
  color: ${grayScale[900]};
  text-align: center;
`;

export const ModalContent = styled(Typo.Text)`
  margin-top: 8px;

  color: ${grayScale[700]};
  text-align: center;
`;

const Button = styled(motion.button)<{
  $textColor?: string;
  $bgColor?: string;
}>`
  width: 100%;
  padding: 5px 16px;
  border-radius: 8px;

  background-color: ${({ $bgColor }) => $bgColor || "transparent"};

  color: ${({ $textColor }) => $textColor || grayScale.white};
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  align-items: center;

  margin-top: 24px;
`;

export const ConfirmButton = styled(Button)`
  background-color: transparent;
`;

export const CancelButton = styled(Button)`
  background-color: transparent;
`;
